<template>
  <div>
    <div class="page-header">
      <div
        class="page-header-content container-fluid header-elements-md-inline"
      >
        <div class="d-flex">
          <div class="page-title">
            <h4 class="font-weight-semibold">
              Periodo {{ period.PS_PERIODO_NOME }}
            </h4>
            <div class="text-muted">
              Referente à {{ period.PS_PERIODO_REFERENCIA }}!
            </div>
          </div>
          <a href="#" class="header-elements-toggle text-body d-md-none"
            ><i class="icon-more"></i
          ></a>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <div class="card">
            <div class="card-img-actions mx-1 mt-1">
              <img
                class="card-img img-fluid m-25"
                src="@/assets/img/icon/select-client.png"
                alt=""
              />
            </div>

            <div class="card-body text-center">
              <h6 class="font-weight-semibold htt">Selecionar Clientes</h6>
              <p class="text-muted htd">Cadastra clientes para para pesquisa</p>
              <router-link
                :to="`${periodId}/select-clients`"
                class="btn btn-dark ml-2"
                title="Acessar"
              >
                Acessar
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <div class="card">
            <div class="card-img-actions mx-1 mt-1">
              <img
                class="card-img img-fluid m-25"
                src="@/assets/img/icon/whatsapp.png"
                alt=""
              />
            </div>

            <div class="card-body text-center">
              <h6 class="font-weight-semibold htt">
                Enviar Pesquisa por WhatsApp
              </h6>
              <p class="text-muted htd">
                Envia mensagem de WhatsApp em lote para os clientes deste
                período!
              </p>
              <router-link
                :to="`${periodId}/whatsapp`"
                class="btn btn-dark ml-2"
                title="Acessar"
              >
                Acessar
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.htd {
  min-height: 60px;
}
.htt {
  min-height: 50px;
}
</style>
<script>
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      periodId: this.$route.params.periodId,
      unityId: '',
      period: {
        PS_PERIODO_NOME: '',
        PS_PERIODO_REFERENCIA: '',
      },
      units: null,
      customers: null,
    }
  },
  watch: {},
  methods: {
    async loadPeriod() {
      try {
        this.period = await this.$store.dispatch('getPeriod', this.periodId)
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },
  mounted() {
    this.loadPeriod()
  },
}
</script>
